import { InstrumentDO } from "score_data";
import { IFingeringVisualizer } from "./IFingeringVisualizer";
import { RecorderFingerings } from "./RecorderFingerings";

export class RecorderFingeringVisualizer implements IFingeringVisualizer {
	/** To use, create a div in your HTML with an id matching the static
	 *  [fingeringDivId] value (you can set this before creating this handler).*/
	
	public static fingeringsDivId:string = "_sp-fingeringsDiv";
	
	private _inst:InstrumentDO;
	private _fingeringsDiv:HTMLDivElement;
	private _svgElement:SVGElement;
	
	// static html.NodeValidatorBuilder _validator;
	
	/**a list of the finger holes, starting with 0 as the thumb*/
	private _fingerHoleSvgGroups:Array<SVGElement>;
	
	/**matches a fingerings set from [_RecorderFingerings] class*/
	private _fingerings:Array<Array<number>>;
	
	public recorderSvg:string = `
		<svg viewBox="0 0 100 800"
				preserveAspectRatio="xMidYMin meet"
				version="1" xmlns="http://www.w3.org/2000/svg" 
				fill-rule="evenodd" clip-rule="evenodd" 
				stroke-linecap="round">
			<g>
				<path d="M5 769c30 11 61 10 90 0l-6-97H11l-6 97zM11 
					671h78l6-649H5l6 649z" fill="#803300" fill-rule="nonzero" 
					stroke="#000" stroke-width="3"/>
				<path d="M11 2c27 9 53 8 78 0 5 0 9 4 9 10v12c0 6-4 10-9 10-25 
					6-51 5-78 0-5 0-9-4-9-10V12C2 6 6 2 11 2z" fill="#ffe6d5" 
					fill-rule="nonzero" stroke="#000" stroke-width="3"/>
				<path fill="#ffe6d5" d="M7 123h86v4H7zM10 393h80v3H10z"/>
				<path d="M5 665c0-6 90-6 90 0v11c0 6-90 6-90 0v-11zM13 765c25 
					7 46 8 74 0 5 0 10 4 10 10v9c0 6-5 11-10 11-25 6-49 3-74 0-5
					0-10-5-10-11v-9c0-6 5-10 10-10z" fill="#ffe6d5" 
					fill-rule="nonzero" stroke="#000" stroke-width="3"/>
			</g>
			<g id="_sp-recHole0" transform="translate(50 80)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole1" transform="translate(50 180)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole2" transform="translate(50 260)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole3" transform="translate(50 340)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole4" transform="translate(50 450)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole5" transform="translate(50 530)">
				${RecorderFingeringVisualizer.closedHole}
				${RecorderFingeringVisualizer.halfHole}
				${RecorderFingeringVisualizer.openHole}</g>
			<g id="_sp-recHole6" transform="translate(36 610)">
				${RecorderFingeringVisualizer.doubleClosedHole}
				${RecorderFingeringVisualizer.doubleHalfHole}
				${RecorderFingeringVisualizer.doubleOpenHole}</g>
			<g id="_sp-recHole7" transform="translate(34 725)">
				${RecorderFingeringVisualizer.doubleClosedHole}
				${RecorderFingeringVisualizer.doubleHalfHole}
				${RecorderFingeringVisualizer.doubleOpenHole}</g>
		</svg>
	`;
	
	public static openHole:string = `
		<circle cx="0" cy="0" r="25" fill="#FFF" stroke="#000" 
			stroke-width: "3" style="visibility: hidden;"/>
	`;
	
	public static closedHole:string = `
		<circle cx="0" cy="0" r="25" fill="#000" stroke="#000" 
			stroke-width: "3" style="visibility: hidden;"/>
	`;
	
	public static halfHole:string = `
		<g style="visibility: hidden;">
			<circle cx="0" cy="0" r="25" fill="#FFF" stroke="#000" 
				stroke-width: "3"/>
			<path d="M-25,0 a1,1 0 0,0 50,0" fill="black" />
		</g>
	`;
	
	public static doubleOpenHole:string = `
		<g style="visibility: hidden;">
			<circle cx="0" cy="0" r="15" fill="#FFF" stroke="#000" 
				stroke-width: "3"/>
			<circle cx="32" cy="6" r="10" fill="#FFF" stroke="#000" 
				stroke-width: "3"/>
		</g>
	`;
	
	public static doubleClosedHole:string = `
		<g style="visibility: hidden;">
			<circle cx="0" cy="0" r="15" fill="#000" stroke="#000" 
				stroke-width: "3"/>
			<circle cx="32" cy="6" r="10" fill="#000" stroke="#000" 
				stroke-width: "3"/>
		</g>
	`;
	
	public static doubleHalfHole:string = `
		<g style="visibility: hidden;">
			<circle cx="0" cy="0" r="15" fill="#000" stroke="#000" 
				stroke-width: "3"/>
			<circle cx="32" cy="6" r="10" fill="#FFF" stroke="#000" 
				stroke-width: "3"/>
		</g>
	`;
	
	constructor(instrument:InstrumentDO){
		this._inst = instrument;
		this._init();
	}
	
	private _init():void {
		//pick the fingering set
		if (this._inst.id === 300 || this._inst.id === 303){
			this._fingerings = (this._inst.fingeringSet === 1)
				? RecorderFingerings.altoUntransposedGermanFingerings
				: RecorderFingerings.altoUntransposedFingerings;
		}
		else {
			this._fingerings = (this._inst.fingeringSet === 1)
				? RecorderFingerings.germanFingerings
				: RecorderFingerings.baroqueFingerings;
		}
		
		this._draw();
	}
	
	public destroy():void {
		this._fingeringsDiv.innerHTML = "";
	}
	
	public showFingering(displayCents:number):void {
		//_svgElement.remove();
		let index:number = ~~(displayCents / 100) - 60;
		if (index >= 0 && index < this._fingerings.length) {
			let holeSettings = this._fingerings[index];
			for (let i = 0; i < holeSettings.length; i++){
				let setting:number = holeSettings[i];
				let svgGroup = this._fingerHoleSvgGroups[i];
				(svgGroup.children[0] as HTMLElement).style.visibility =
					(setting === 0) ? "visible" : "hidden";
				(svgGroup.children[1] as HTMLElement).style.visibility =
					(setting === 1) ? "visible" : "hidden";
				(svgGroup.children[2] as HTMLElement).style.visibility =
					(setting === 2) ? "visible" : "hidden";
			}
		}
		//_fingeringsDiv.append(_svgElement);
	}
	
	private _draw():void {
		//create the recorder bg
		this._fingeringsDiv = document.querySelector(
			`#${RecorderFingeringVisualizer.fingeringsDivId}`);
		if (this._fingeringsDiv != null){
			let div = document.createElement('div');
			div.innerHTML = this.recorderSvg;
			this._svgElement = div.children[0] as SVGElement;
			this._svgElement.remove();
			this._fingeringsDiv.append(this._svgElement);
		}
		
		//create the graphics for the holes and get the svg groups they go in.
		this._fingerHoleSvgGroups = [];
		for (let i = 0; i < 8; i++){
			this._fingerHoleSvgGroups.push(
				this._svgElement.querySelector(`#_sp-recHole${i}`));
		}
	}
}